import * as Actions from 'app/store/actions/countries';

const initialState = {
  data: []
};

const countriesReducer = function (state = initialState, action) {
  switch (action.type) {
    case Actions.GET_COUNTRIES: {
      return {
        ...state,
        data: action.payload
      };
    }
    case Actions.GET_COUNTRIES_FOR_A_SPECIFIC_BRAND: {
      return {
        ...state,
        data: action.payload
      };
    }
    default: {
      return state;
    }
  }
};

export default countriesReducer;
